import { InsetWrap, Title } from "@citydna/common"
import { Button } from "@material-ui/core"
import React from "react"
import { Link } from "react-router-dom"

export class ErrorBoundary extends React.Component {
  state = { error: undefined }

  static getDerivedStateFromError(error: Error) {
    console.log("error")

    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <InsetWrap>
          <Title
            primary="Damn, that's an error!"
            secondary="Please contact Sixto (sixto.tantiongco@melbourne.vic.gov.au) in the City Insights teams for assistance."
          />
          <Button variant="contained" color="secondary" component={Link} to="/">
            Go home
          </Button>
        </InsetWrap>
      )
    }

    return this.props.children
  }
}
